import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import omit from 'lodash.omit'

import Header from '../../organisms/Header'
import Footer from '../../organisms/Footer'

const AppContent = styled.div`
  background-color: ${({ theme }) => theme.colors.gray };
  font-family: 'Source Sans Pro', sans-serif;
  height: 100%;
  overflow-x: hidden;
`

const App = props => {
  const { children, language, onChangeLanguage } = props

  const passingProps = omit(props, ['children'])

  return (
    <AppContent>
      <Header
        language={language}
        onChangeLanguage={onChangeLanguage}
      />
      {React.cloneElement(children, passingProps)}
      <Footer />
    </AppContent>
  )
}

App.propTypes = {
  children: PropTypes.node.isRequired,
  onChangeLanguage: PropTypes.func.isRequired
}

export default App



// WEBPACK FOOTER //
// ./src/components/templates/App/App.js